import { createStore, compose } from "redux";

import {
  // eslint-disable-next-line no-unused-vars
  Actions,
} from "./actions";

// eslint-disable-next-line no-unused-vars
import { ReduxState } from "./ReduxState";

const initStore : ReduxState = {
  authentication: {
    isAuthenticated: true,
    retryHandlers: [],
    accessToken: null,
    tokenExpirationDate: new Date(),
    tokenCreationDate: new Date(),
  },
  userBasicDetails: null,
  subscriptionsAllowedFeatures: [],
  showError: false,
  apiErrors: {
    errors: [],
  },
};

const reducer = (state = initStore, action: {type: Actions, payload: any }): ReduxState => {
  switch (action.type) {
    case "SET_NOT_AUTHENTICATED": {
      return {
        ...state,
        authentication: {
          ...state.authentication,
          isAuthenticated: action.payload.isAuthenticated,
          accessToken: null,
          retryHandlers: action.payload.isAuthenticated ? [] : [
            ...state.authentication.retryHandlers,
            action.payload.retryHandler],
        },
      };
    }

    case "SET_AUTH_TOKEN": {
      return {
        ...state,
        authentication: {
          ...state.authentication,
          accessToken: action.payload.accessToken,
          tokenCreationDate: action.payload.tokenCreationDate,
          tokenExpirationDate: action.payload.tokenExpirationDate,
        },
      };
    }

    case "SET_USER_BASIC_DETAILS": {
      return {
        ...state,
        userBasicDetails: action.payload,
      };
    }
    case "SET_SUBSCRIPTION_ALLOWED_FEATURES": {
      return {
        ...state,
        subscriptionsAllowedFeatures: action.payload,
      };
    }
    case "SET_SHOW_ERROR": {
      return {
        ...state,
        showError: action.payload,
      };
    }
    case "ADD_API_ERROR": {
      return {
        ...state,
        apiErrors: {
          errors: [...state.apiErrors.errors, action.payload.apiError],
        },
      };
    }
    case "CLEAR_API_ERRORS": {
      return { ...state, apiErrors: { ...state.apiErrors, errors: [] } };
    }
    default: {
      return { ...state };
    }
  }
};

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default createStore(reducer, composeEnhancers());
